@import '~style-sheet-helpers/core.less';

.other-shipping-options-form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 14px;
  font-weight: 500;
}

.option-section {
  font-size: 14px;

  > div {
    margin: 15px 0;
  }

  div[class^='checkbox'] {
    height: auto;
  }

  label {
    font-size: 14px;
  }
}

.bill-to-account-section {
  font-size: 14px;
  display: flex;
  flex-wrap: nowrap;
}

@media screen and (max-width: 1199px) {
  .option-section {
    > div {
      margin-bottom: 10px;
    }

    div[class^='checkbox'] {
      height: 100%;
    }

    label {
      font-size: 13px;
    }
  }
}
